import { render, staticRenderFns } from "./Resolve.vue?vue&type=template&id=1f3ce9a0&scoped=true&"
import script from "./Resolve.vue?vue&type=script&lang=ts&"
export * from "./Resolve.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ce9a0",
  null
  
)

export default component.exports